import axios          from "axios"
import BaseApiService from "@/api/BaseApiService"

export default class ProjectService extends BaseApiService {
  getAll(q: string) {
    const url = this.getApiUrl("/project/index?q=" + q, "general")
    return this.processRequest(axios.get(url))
  }

  getById(id: number) {
    const url = this.getApiUrl(`/project/view?id=${id}`, "general")
    return this.processRequest(axios.get(url))
  }
}
